import {
  Container,
  TableContainer,
  TableHead,
  makeStyles,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TextField,
  Divider,
  Paper,
  Dialog, DialogActions, DialogContent, DialogTitle,
  CircularProgress,
  IconButton,
  Tooltip,
  Button,
} from "@material-ui/core";

import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import RestorePageIcon from '@material-ui/icons/RestorePage';
import DeleteIcon from "@material-ui/icons/Delete";

import { useState, useEffect, useRef } from "react";
import TableHeaders from "../utils/SearchFanTableHeaders";
import { getBladeModelAPI } from "../app/api/util";
import { getAllArchievedFansData, getAllFansData, restoreFan } from "../app/reducer/fan.reducer";
import {removeHardModel, removeModel } from "../app/reducer/fanUpload.reducer"
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import AlertDialog from "./AlertDialog";
import { restorefan } from "../app/api/fan";


const DeleteDialog = ({ open, onClose, onConfirm }:any) => {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Delete Item</DialogTitle>
        <DialogContent>
          Deleting the item from here cannot be retrieved. Are you sure want to delete ?
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={onConfirm} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  };


const useStyles = makeStyles({
    container: {
        backgroundColor: "#FFFFFF",
        marginTop: "5%"
    },
     cell: {
        width: "250px",
        fontSize:'20px'
    },
    biggerCell: {
        width: "250px",
        fontSize:'20px'
    },
    duplicateButton: {
        width: "40px",
        fontSize: "10px",
        color: "orange",
    },
    editButton: {
        width: "40px",
        fontSize: "10px",
        color: "green",
    },
    deleteButton: {
        width: "40px",
        fontSize: "10px",
        color: "red",
    },
    searchInput: {
        width: "400px"
    },
    editIcon: { color: "#059669",height:'40px',width:'40px',marginRight:'20px' },
    duplicateIcon: { color: "#3B82F6",height:'40px',width:'40px',marginRight:'20px'  },
    deleteIcon: { color: "#EF4444",height:'40px',width:'40px',marginRight:'20px'  },
});

const HEADERS_CONSTANT = {
    fanModel: "FAN_MODEL",
    fanDia: "FAN_DIA",
    clientName: "CLIENT_NAME",
    projectName: "PROJECT_NAME",
    location: "LOCATION",
    angleRange: "ANGLE_RANGE",
};

// ! TODO - DUMMY DATA WE NEED TO REMOVE.
const DUMMY_DATA = [
    ["1234", "123", "DUMMY 1", "PROJECT 1111111111111", "LOCATION 1", "RANGE"],
    ["1234", "123", "DUMMY 1", "PROJECT 11", "LOCATION 1", "RANGE"],
    ["1234", "123", "DUMMY 1", "PROJECT 11", "LOCATION 1", "RANGE"],
];

const HEADER_SELECT_MIN_WIDTH_200 = 200;
const HEADER_SELECT_MIN_WIDTH_120 = 100;
const HEADER_SELECT_MIN_WIDTH_LARGE = 130;
const HEADER_SELECT_MIN_WIDTH_SMALL = 80;

function ArchieveFanScreen() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch()

    const cache: any = {};
    const memoizedGetBladeModels = async () => {
        if (cache.bladeModels) {
            return cache.bladeModels;
        }
        const bladeModels = await dispatch(getAllArchievedFansData());
        console.log(bladeModels);
        const blademodels2 = await dispatch(getAllFansData());
        // console.log(bladeModels)
        cache.bladeModels = bladeModels;
        return {bladeModels,blademodels2};
    };

    const fetchUpdatedData = async () => {
        const {bladeModels,blademodels2} = await memoizedGetBladeModels();//await getBladeModelAPI();console.log(bladeModels)
        console.log(bladeModels);
        const options = bladeModels.payload.data.map((element: any) => element.fanModelID);
        setFanModelNumber(options);
        setClientList(Array.from(new Set(bladeModels.payload.data.map((element: any) => element.clientName))));
        setProjectList(Array.from(new Set(bladeModels.payload.data.map((element: any) => element.projectName))));
        setLocationList(Array.from(new Set(bladeModels.payload.data.map((element: any) => element.location))));
        console.log(blademodels2)
        setFanModelData(bladeModels.payload.data)
        setFanModelDataMain(blademodels2.payload.data.map((e:any)=>(e.fanModelID)))
        originalFanModelData.current = bladeModels.payload.data;
        console.log(bladeModels.payload.data)

        const diameter = bladeModels.payload.data.map(
            (element: any) => element.fanDiameter.toFixed(3)
        ).filter((val:any,ind:any,arr:any) => arr.indexOf(val) === ind).sort((a: any, b: any) => a - b);

        setFanDiameter(diameter)
        setLoading(false);
    };

    const [fanModel, setFanModel] = useState("");
    const [fanDia, setFanDia] = useState("");
    const [clientName, setClientName] = useState("");
    const [projectName, setProjectName] = useState("");
    const [location, setLocation] = useState("");
    const [angleRange, setAngleRange] = useState("");
    const [fanModelNumber, setFanModelNumber] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [locationList, setLocationList] = useState([]);

    const [fanDiameter, setFanDiameter] = useState([]);
    const [fanModelData, setFanModelData] = useState([]);
    const [fanModelDataMain, setFanModelDataMain] = useState<string[]>([]);
    const originalFanModelData = useRef(fanModelData);
    const [warningDialog, setWarningDialog] = useState(false);
    const [warningDialogText, setWarningDialogText] = useState("");
    const [openAlert, setOpenAlert] = useState<boolean>(false);
    const [openAlertMesage, setOpenAlertMessage] =useState<string>("");

    const [searchString, setSearchString] = useState<string>('');
    const [loading,setLoading] = useState(false);

    const rowKeys=["fanModelID","fanDiameter","projectName","clientName","location"]

    useEffect(() => {
        if ( originalFanModelData.current) {
             const tempData = [...originalFanModelData.current];
            if (searchString) {
               let filteredArr:any = [];
                 tempData.map((item)=>{
                  return rowKeys.map((item2)=>{
                     if(`${item[item2]}`.toLowerCase().includes(searchString.toLowerCase())){
                        filteredArr.push(item)
                       return  item;
                      } 
                   })
                })

                console.log(filteredArr);

                setFanModelData(filteredArr);
            }
            else {
                setFanModelData(originalFanModelData.current);
            }
        } else {
            setFanModelData([]);
        }

    }, [originalFanModelData.current, searchString])

    useEffect(() => {
        setLoading(true);
        fetchUpdatedData();
    }, []);

    const handleDropDownChange = (event: any) => {
        console.log({
            name:event.target.name,
            value:event.target.value
        })
        switch (event.target.name) {
            case HEADERS_CONSTANT.fanModel:
                setFanModel(event.target.value);
                const fanSelectedItem = originalFanModelData.current?.filter((item: any) => item.fanModelID == event.target.value);
                console.log("fanSelectedItem",fanSelectedItem);
                if (fanSelectedItem && event.target.value) {
                    setFanModelData(fanSelectedItem);
                } else {
                    setFanModelData(originalFanModelData.current);
                }
                break;
            case HEADERS_CONSTANT.fanDia:
                setFanDia(event.target.value);
                const daiSelectedItem = originalFanModelData.current?.filter((item: any) => item.fanDiameter.toFixed(3) == event.target.value);
                if (daiSelectedItem && event.target.value) {
                    setFanModelData(daiSelectedItem);
                } else {
                    setFanModelData(originalFanModelData.current);
                }
                break;
            case HEADERS_CONSTANT.clientName:
                setClientName(event.target.value);
                const clientSelectedItem = originalFanModelData.current?.filter((item: any) => item.clientName == event.target.value);
                if (clientSelectedItem && event.target.value) {
                    setFanModelData(clientSelectedItem);
                } else {
                    setFanModelData(originalFanModelData.current);
                }
                break;
            case HEADERS_CONSTANT.projectName:
                setProjectName(event.target.value);
                const projectSelectedItem = originalFanModelData.current?.filter((item: any) => item.projectName == event.target.value);
                if (projectSelectedItem && event.target.value) {
                    setFanModelData(projectSelectedItem);
                } else {
                    console.log(originalFanModelData)
                    setFanModelData(originalFanModelData.current);
                }
                break;
            case HEADERS_CONSTANT.location:
                setLocation(event.target.value);
                const locationSelectedItem = fanModelData?.filter((item: any) => item.location == event.target.value);
                if (locationSelectedItem && event.target.value) {
                    setFanModelData(locationSelectedItem);
                } else {
                    console.log(originalFanModelData)
                    setFanModelData(originalFanModelData.current);
                }
                break;
            case HEADERS_CONSTANT.angleRange:
                setAngleRange(event.target.value);
                break;
        }
    };

    const editFan = (fanModelID: any) => {
        //debugger;
        const selectedFan = fanModelData?.find((item: any) => item.fanModelID == fanModelID);
        history.push('/fans', { selectedFan: selectedFan, fanAction: 'Update' })
    }

    // const duplicateFan = (fanModelID: any) => {
    //     debugger;
    //     const selectedFan = fanModelData?.find((item: any) => item.fanModelID == fanModelID);
    //     history.push('/fans', { selectedFan: selectedFan, fanAction: 'Save' })
    // }
    const RestoreFan = async(fanModelID: string) => {
  console.log(fanModelID, fanModelDataMain);

        if (fanModelDataMain.includes(fanModelID)) {
            const altName = prompt(
            "This fan model already exists. Enter an alternate name:"
            );

            if (!altName) return; // user cancelled
            setLoading(true);
            await dispatch(restoreFan({fanModelID,altName}));
            fetchUpdatedData();
        }
        else
        {
            console.log("Unique name found")
            setLoading(true);
            await dispatch(restoreFan({fanModelID}));
            fetchUpdatedData();
        }
};

    const deleteFan = (fanModelID: any) => {
        setOpenDialog({fanModelID:fanModelID})
    };

    const [openDialog, setOpenDialog] = useState({fanModelID:false});

    const handleDelete = async () => {
        setLoading(true);
        await dispatch(removeHardModel(openDialog));
        setOpenAlertMessage('Fan Deleted successfully');
        setOpenDialog({fanModelID:false});
        fetchUpdatedData();
    };


    return (
        <div className="page-wrapper">
            <Container maxWidth="xl">
                <Paper className="form-wrapper">
                    <Typography variant="h5" gutterBottom>
                        <b> ARCHIVED FAN LIST</b>
                    </Typography>
                    <hr />
                    <Divider />
                    {/* <AlertDialog  open={openAlert} message={openAlertMesage} handleClose={() => { setOpenAlert(false);refresh()}} /> */}
                    <DeleteDialog 
                        open={openDialog.fanModelID} 
                        onClose={() => 
                        setOpenDialog({fanModelID:false})} 
                        onConfirm={handleDelete} 
                    />

                    <TextField id="outlined-basic" label="Search" variant="outlined" 
                    className={classes.searchInput}
                    onChange={(e) => setSearchString(e.target.value)}
                     />

                    <TableContainer style={{ maxHeight: '600px', overflowY: 'auto' }}>
                        <Table>
                            <TableHead style={{ position: 'sticky', top: 0, backgroundColor:"white",zIndex:1 }}>
                                <TableRow>
                                    <TableCell>
                                        <TableHeaders
                                            style={{fontSize:'30px' }}
                                            label={"FAN MODEL"}
                                            name={HEADERS_CONSTANT.fanModel}
                                            minSize={HEADER_SELECT_MIN_WIDTH_200}
                                            handleChange={handleDropDownChange}
                                            values={fanModel}
                                            options={fanModelNumber}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TableHeaders
                                            label={"FAN DIA"}
                                            name={HEADERS_CONSTANT.fanDia}
                                            minSize={HEADER_SELECT_MIN_WIDTH_200}
                                            handleChange={handleDropDownChange}
                                            values={fanDia}
                                            options={fanDiameter}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.biggerCell}>
                                        <TableHeaders
                                            label={"CLIENT NAME"}
                                            name={HEADERS_CONSTANT.clientName}
                                            minSize={HEADER_SELECT_MIN_WIDTH_200}
                                            handleChange={handleDropDownChange}
                                            values={clientName}
                                            options={clientList}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.biggerCell}>
                                        <TableHeaders
                                            label={"PROJECT NAME"}
                                            name={HEADERS_CONSTANT.projectName}
                                            minSize={HEADER_SELECT_MIN_WIDTH_200}
                                            handleChange={handleDropDownChange}
                                            values={projectName}
                                            options={projectList}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.biggerCell}>
                                        <TableHeaders
                                            label={"LOCATION"}
                                            name={HEADERS_CONSTANT.location}
                                            minSize={HEADER_SELECT_MIN_WIDTH_200    }
                                            handleChange={handleDropDownChange}
                                            values={location}
                                            options={locationList}
                                        />
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fanModelData.map((element: any) => {
                                    return (
                                        <TableRow>
                                            <TableCell className={classes.cell}>{element.fanModelID}</TableCell>
                                            <TableCell className={classes.cell} >{element.fanDiameter.toFixed(3)}</TableCell>
                                            <TableCell className={classes.biggerCell}>{element.clientName}</TableCell>
                                            <TableCell className={classes.biggerCell}>{element.projectName}</TableCell>
                                            <TableCell className={classes.biggerCell}>{element.location}</TableCell>
                                            <TableCell></TableCell>
                                                <TableCell>
    <Tooltip title="Edit">
        <IconButton
        aria-label="edit"
        onClick={() => editFan(element.fanModelID)}
        className={classes.editIcon}
        size="small"
        >
        <EditIcon /> Edit
        </IconButton>
    </Tooltip>
    </TableCell>

<TableCell>
  <Tooltip title="Restore">
    <IconButton
      aria-label="Restore"
      onClick={() => RestoreFan(element.fanModelID)}
      className={classes.duplicateIcon}
      size="small"
    >
      <RestorePageIcon /> Restore
    </IconButton>
  </Tooltip>
</TableCell>

<TableCell>
  <Tooltip title="Delete">
    <IconButton
      aria-label="delete"
      onClick={() => deleteFan(element.fanModelID)}
      className={classes.deleteIcon}
      size="small"
    >
      <DeleteIcon /> Delete
    </IconButton> 
  </Tooltip>
</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
                <Dialog open={loading} aria-labelledby="delete-dialog-title">
            <DialogContent>
                <CircularProgress />
              </DialogContent>
           </Dialog>
            </Container>
        </div>
    );
}

export default ArchieveFanScreen;
